import { Switch, Tooltip } from '@mui/material';

export const AbvOpenPeriodToggleButton = ({ paidPeriodFlag, setPaidPeriodFlag }) => {

  return (
    <Tooltip title={'Open Period Toggle'} >
      <Switch
        color={'success'}
        checked={paidPeriodFlag}
        onChange={(e) => setPaidPeriodFlag(e.target.checked)}
      />
    </Tooltip>
  )
}